import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h3" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "q-pt-sm row items-center" }
const _hoisted_4 = { class: "q-ml-sm col" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxCardWorkOrderIssueCondensed from "src/components/card/SfxCardWorkOrderIssueCondensed.vue"
import { useLocalUserSettingsStore } from "src/stores/localUserSettingsStore"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { IssueCardData } from "src/util/types/dataModels/issue"
import { PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogWorkOrderRemoveIssue',
  props: {
  issue: {
    type: Object as PropType<IssueCardData>,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const { t } = useI18n()

const title = t("sfxDialogWorkOrderRemoveEntity.title_issue")
const content = t("sfxDialogWorkOrderRemoveEntity.content_issue")
const label = t("sfxDialogWorkOrderRemoveEntity.label")
const rejectButtonText = t("sfxButtons.btn_cancel")
const confirmButtonText = t("sfxButtons.btn_confirm")
const dialogStyle = { width: "580px" }

const dontAskAgain = ref(false)

//endregion

//region Function

function handleDialogOk() {
  if (dontAskAgain.value) {
    useLocalUserSettingsStore().skipConfirmWorkOrderRemoveIssue = true
  }
  onDialogOK()
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "q-dialog-plugin",
        style: dialogStyle
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-pb-lg" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: "text-body1",
                innerHTML: _unref(content)
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pb-sm" }, {
            default: _withCtx(() => [
              _createVNode(SfxCardWorkOrderIssueCondensed, {
                issue: props.issue,
                clickable: false
              }, null, 8, ["issue"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_checkbox, {
                  size: "56px",
                  class: "sfx-checkbox",
                  "checked-icon": _unref(Icons).ACCEPT,
                  modelValue: dontAskAgain.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dontAskAgain).value = $event))
                }, null, 8, ["checked-icon", "modelValue"]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(label)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-px-md q-pb-md q-pt-sm gap-sm" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                label: _unref(rejectButtonText),
                onClick: _unref(onDialogCancel),
                class: "col"
              }, null, 8, ["label", "onClick"]),
              _createVNode(SfxBtn, {
                label: _unref(confirmButtonText),
                onClick: handleDialogOk,
                class: "col"
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})